import Text from '@components/Text';
import styled from '@emotion/styled';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import { useRef } from 'react';

import CloseIcon from './CloseIcon';
import useBottomSheetEffect from './hooks/useBottomSheetEffect';
import useBottomSheetValues from './hooks/useBottomSheetValues';
import * as styles from './styles';

function BottomSheets() {
    const { closeBottomSheet } = useBottomSheet();
    const { children, title } = useBottomSheetValues();
    const ref = useRef<HTMLDivElement>(null);
    useBottomSheetEffect(ref);
    return (
        <div className={`${styles.backdrop} ${styles.none} ${styles.hide}`}
            ref={ref}>
            <Container>
                <Header>
                    <Text size='lg' fontWeight='bold'>{title}</Text>
                    <CloseIcon onClick={closeBottomSheet}/>
                </Header>
                {children}
            </Container>
        </div>
    );
}

const Container = styled.div`
    background-color: var(--color-white);
    border-radius: 12px 12px 0 0;
    margin: 0 auto;
    max-height: 90vh;
    max-width: var(--max-view-port-width);
    padding-bottom: var(--safe-area-bottom);
    transition: 250ms ease-in-out;
    width: 100%;

    @media (max-width: 768px) {
        max-width: unset;
    }
`;

const Header = styled.header`
    align-items: center;
    border-bottom: 1px solid var(--color-gray3);
    display: flex;
    justify-content: center;
    padding: 20px 0;
    position: relative;
`;

export default BottomSheets;
